"use strict";
/**
 * RedPanda UI - Pagination Export
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListPagination = exports.Pagination = void 0;
var Pagination_1 = require("./Pagination");
Object.defineProperty(exports, "Pagination", { enumerable: true, get: function () { return Pagination_1.Pagination; } });
var ListPagination_1 = require("./ListPagination");
Object.defineProperty(exports, "ListPagination", { enumerable: true, get: function () { return ListPagination_1.ListPagination; } });
